import React from "react";
import { dateFormator, mapTableRows } from "../../../../utils";
import { Button, NewTable } from "../../../../components";

const ActiveEmployees = () => {
  const tableData = [
    {
      employeeName: "Aaron Carter",
      employeeId: "CS-2064",
      employeeType: "Consultant",
      payFrequency: "--",
      paymentType: "--",
      dateOfJoining: "2025-12-09T00:00:00.000Z",
      employeeEmail: "aaroncarter@gmail.com",
      mobile: "919 333 0015",
      configuredOn: "--",
    },
    {
      employeeName: "Abdul Waseem Syed",
      employeeId: "EMP-1001",
      employeeType: "Employee",
      payFrequency: "Monthly (W2 Payroll (Monthly))",
      paymentType: "Hourly",
      dateOfJoining: "2025-05-06T00:00:00.000Z",
      employeeEmail: "abdul@tektree.com",
      mobile: "919 333 0015",
      configuredOn: "2025-04-14T00:00:00.000Z",
    },
    {
      employeeName: "Abdul Muqeeth",
      employeeId: "CON-1780",
      employeeType: "Contract",
      payFrequency: "--",
      paymentType: "--",
      dateOfJoining: "2025-09-12T00:00:00.000Z",
      employeeEmail: "abdul@tektree.com",
      mobile: "919 333 0015",
      configuredOn: "--",
    },
    {
      employeeName: "Abdul Waseem Syed",
      employeeId: "EMP-1001",
      employeeType: "Employee",
      payFrequency: "Monthly (W2 Payroll (Monthly))",
      paymentType: "Hourly",
      dateOfJoining: "2025-23-06T00:00:00.000Z",
      employeeEmail: "abdul@tektree.com",
      mobile: "919 333 0015",
      configuredOn: "--",
    },
  ];
  const columns = [
    {
      key: "employeeName",
      label: "Employee Name",
    },
    {
      key: "employeeId",
      label: "Employee Id",
    },
    {
      key: "employeeType",
      label: "Employee Type",
    },
    {
      key: "payFrequency",
      label: "Pay Frequency",
    },
    {
      key: "paymentType",
      label: "Payment Type",
    },
    {
      key: "dateOfJoining",
      label: "Date of Joining",
      render: (row) => dateFormator(row.dateOfJoining, "month-day-year"),
    },
    {
      key: "employeeEmail",
      label: "Employee Email",
    },
    {
      key: "mobile",
      label: "Mobile",
    },
    {
      key: "configuredOn",
      label: "Configured On",
      render: (row) => dateFormator(row.configuredOn, "datetime"),
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);
  return (
    <div>
      <NewTable
        rows={mappedRows}
        columns={columns}
        toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
        customSection={
          <div>
            <Button title={"Search"} size="sm" />
          </div>
        }
      />
    </div>
  );
};

export default ActiveEmployees;
